module.exports = __webpack_public_path__ + "img/posiedzenia.68af0a73.svg";